"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const makeStyles_1 = __importDefault(require("@material-ui/styles/makeStyles"));
const Image_1 = __importDefault(require("../shared/Image"));
const Video_1 = __importDefault(require("../shared/Video"));
exports.default = react_1.default.memo(DraftMediaMessage);
const useStyles = makeStyles_1.default(() => ({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    media: {
        margin: 14,
        marginBottom: 4,
        borderRadius: 16,
        "& *": {
            borderRadius: "inherit"
        },
        "& img": {
            maxWidth: props => props.isLandscape ? "calc(var(--vh, 1vh) * 50)" : "none",
            maxHeight: props => props.isLandscape ? "none" : "calc(var(--vh, 1vh) * 50)",
            width: props => props.isLandscape ? "100%" : "auto",
            height: props => props.isLandscape ? "auto" : "100%",
        }
    }
}));
function DraftMediaMessage(props) {
    const classes = useStyles({ isLandscape: props.width > props.height });
    return (react_1.default.createElement("div", { className: classes.container },
        react_1.default.createElement("div", { className: classes.media }, props.mimeType.startsWith("image/")
            ? react_1.default.createElement(Image_1.default, { src: props.blobUrl })
            : react_1.default.createElement(Video_1.default, { src: props.blobUrl }))));
}
